<dialog
  #dialog
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="modal-title"
  (click)="onDialogClick($event)"
  (keydown)="onDialogKeydown($event)">
  <h2 id="modal-title">Guide de syntaxe</h2>

  <div class="modal-content">
    <section>
      <h3>Déclarer les participants</h3>
      <code>actor NomActeur<br />entity NomEntité</code>
    </section>

    <section>
      <h3>Envoyer des messages</h3>
      <code>Source -> Destination: Message</code>
    </section>

    <section>
      <h3>Exemple</h3>
      <code>
        actor Utilisateur<br />
        entity API<br />
        entity Database<br />
        Utilisateur -> API: Requête<br />API -> Database: SELECT<br />Database -> API: Résultat</code
      >
    </section>
  </div>

  <button type="button" class="close-modal" (click)="closeModal()" aria-label="Fermer">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4 4L16 16M4 16L16 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</dialog>
